import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { CheckCircle } from 'lucide-react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import infra1 from '../assets/infrastructure/infra-1.jpeg';
import infra2 from '../assets/infrastructure/infra-2.jpeg';
import infra3 from '../assets/infrastructure/infra-3.jpeg';
import infra4 from '../assets/infrastructure/infra-4.jpeg';

const Infrastructure = () => {
    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    arrows: true,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    arrows: false,
                },
            },
        ],
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <Navbar />

            {/* Infrastructure Content */}
            <section className="py-12 sm:py-16 lg:py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-10 lg:gap-16 items-center">
                        {/* Left Side Content */}
                        <div className="animate-fadeInUp">
                            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
                                Our <span className="text-orange-600">Infrastructure</span>
                            </h2>
                            <p className="text-base sm:text-lg text-gray-700 mb-4 sm:mb-6 leading-relaxed">
                                Our advance infrastructure facility is well-established by us for having well execution of all the business activities in a coordinated way. The infrastructure facility of our company is well-equipped with latest machines & technologies that are crucial for bulk production process.
                            </p>
                            <p className="text-base sm:text-lg text-gray-700 mb-4 sm:mb-6 leading-relaxed">
                                We have large storage area for raw materials and finished products to keep the require inventory stock in place to supply products in time to our customers. We designed our manufacturing facilities, machineries and kilns by vision to avoid/minimize any interruptions to produce high quality products consistently.
                            </p>

                            <div className="flex items-center gap-3 text-orange-600 font-semibold text-sm sm:text-base">
                                <CheckCircle className="w-5 h-5 sm:w-6 sm:h-6" />
                                <span>High Capacity Warehousing & Redundant Systems</span>
                            </div>
                        </div>

                        {/* Right Side Slider */}
                        <div className="relative animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
                            <div className="relative overflow-hidden rounded-2xl ">
                                <Slider {...sliderSettings}>
                                    <div>
                                        <img
                                            src={infra1}
                                            alt="Infrastructure 1"
                                            className="w-full h-[250px] sm:h-[300px] lg:h-[400px] object-cover rounded-2xl"
                                        />
                                    </div>
                                    <div>
                                        <img
                                            src={infra2}
                                            alt="Infrastructure 2"
                                            className="w-full h-[250px] sm:h-[300px] lg:h-[400px] object-cover rounded-2xl"
                                        />
                                    </div>
                                    <div>
                                        <img
                                            src={infra3}
                                            alt="Infrastructure 3"
                                            className="w-full h-[250px] sm:h-[300px] lg:h-[400px] object-cover rounded-2xl"
                                        />
                                    </div>
                                    <div>
                                        <img
                                            src={infra4}
                                            alt="Infrastructure 4"
                                            className="w-full h-[250px] sm:h-[300px] lg:h-[400px] object-cover rounded-2xl"
                                        />
                                    </div>
                                </Slider>
                            </div>
                            <div className="absolute -bottom-4 -right-4 sm:-bottom-6 sm:-right-6 bg-gradient-to-r from-yellow-500 to-orange-500 text-white p-4 sm:p-6 rounded-xl shadow-xl">
                                <div className="text-lg sm:text-xl font-bold">Modern Plant</div>
                                <div className="text-xs sm:text-sm">High Capacity</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Custom Styles */}
            <style jsx>{`
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                .animate-fadeInUp {
                    animation: fadeInUp 0.8s ease-out forwards;
                    opacity: 0;
                }
                @media (max-width: 640px) {
                    .slick-prev,
                    .slick-next {
                        display: none !important;
                    }
                    .slick-dots {
                        bottom: -15px;
                    }
                }
            `}</style>

            <Footer />
        </div>
    );
};

export default Infrastructure;

